import axios from 'axios';
import React, { useState } from 'react';
import { useSelector } from 'react-redux';
import { toast } from 'react-toastify';
import { ReactComponent as CloseIcon } from '../Icons/close.svg';
import { ReactComponent as AddStaff } from '../Icons/staff.svg';
import '../Styles/Modal.css';

function EmailVerify({ isOpen, onClose, closeEmailModal, isChangeEmail }) {
  const [formData, setFormData] = useState({ email: '' });
  const [isInputValid, setIsInputValid] = useState(false);
  const [loading, setLoading] = useState(false);

  const { user } = useSelector((state) => state.user);

  const requestOTP = async (email) => {
    let requstData;
    if (isChangeEmail) {
      requstData = { newEmail: email, email: user?.email };
    } else {
      requstData = { email: email };

      const response = await axios.post(
        `${process.env.REACT_APP_BASE_URL}/api/v1/authentication/verifyOtp`,
        requstData
      );

      console.log('OTP sent', response.data);
      if (isChangeEmail) {
        localStorage.setItem('newEmail', JSON.stringify(requstData));
      }
      toast.success('OTP sent');

      return response.data;
    }
    // try {
    //   const response = await axios.post(
    //     `${process.env.REACT_APP_BASE_URL}/api/v1/authentication/requestOtp`,
    //     requstData
    //   );

    //   console.log('OTP sent', response.data);
    //   if (isChangeEmail) {
    //     localStorage.setItem('newEmail', JSON.stringify(requstData));
    //   }
    //   toast.success('OTP sent');
    //   // Check response status before showing PIN
    //   if (response.status === 200) {
    //     setShowPin(true);
    //   }

    //   return response.data;
    // } catch (error) {
    //   console.error('Error sending OTP:', error);
    //   toast.error('Error while sending OTP');
    //   throw error;
    // }
  };

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData((prevData) => ({
      ...prevData,
      [name]: value,
    }));
    setIsInputValid(!!value.trim());
  };

  const handleSubmit = async () => {
    if (!isInputValid) {
      toast.error('Please enter a valid email address');
      return;
    }

    setLoading(true);
    const user = JSON.parse(localStorage.getItem('user'));
    await axios
      .request({
        method: 'PATCH',
        url: `${process.env.REACT_APP_BASE_URL}/api/v1/authentication/updateEmail`,
        data: {
          email: formData.email,
          id: user?._id || '',
          userName: user?.userName || '',
        },
      })
      .then(() => {
        toast.success('Email updated successfully');
        onClose();
      })
      .catch((err) => {
        toast.error(err?.response?.data?.message || 'Something went wrong');
      })
      .finally(() => {
        setLoading(false);
      });
  };

  return isOpen ? (
    <div className='modal-overlay'>
      <div className='modal'>
        <div className='Upper-modal-row'>
          <h2>Change Email</h2>
          <CloseIcon
            onClick={() => {
              onClose();
              setFormData({ email: '' });
            }}
          />
        </div>
        <div className='row' style={{ flexDirection: 'column', gap: '20px' }}>
          <div className='input-boxer'>
            <input
              type='email'
              name='email'
              placeholder={isChangeEmail ? 'Enter new email' : 'Enter email'}
              value={formData.email}
              onChange={handleInputChange}
              required
            />
          </div>
        </div>
        <button
          className='continue-modal-button'
          onClick={handleSubmit}
          disabled={loading}
        >
          {loading ? 'Submitting...' : 'Submit'}
        </button>
      </div>
    </div>
  ) : null;
}

export default EmailVerify;
